import { Component } from "react";
import { Image, Flex, Button } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import NavigationBar from "src/components/NavigationBar";
import { H2, BodyText } from "src/atoms/typography";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";

class NoAvatars extends Component {
  render() {
    const { onClose, onBack, openEditor, t } = this.props;

    const imageSource = getAppValue({
      barkio: "sad-dog.svg",
      bibino: "sad-child.svg"
    });

    return (
      <Flex flexDirection="column" alignItems="center" height="100%">
        <NavigationBar headingKey="avatars" onBack={onBack} onClose={onClose} />
        <Flex
          width="320px"
          pb="24px"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          flex="1 1 auto"
        >
          <Image width="176px" src={getImageSrc(imageSource)} />
          <H2 textAlign="center" color="highEmphasis" mt="24px">
            {t("avatar.noAvatars.heading")}
          </H2>
          <BodyText textAlign="center" mt="8px" color="mediumEmphasis">
            {t("avatar.noAvatars.text")}
          </BodyText>
        </Flex>
        <Flex flex="0 0 auto" mb="24px" justifyContent="center">
          <Button
            variant="containedPrimary"
            onClick={openEditor}
            minWidth="196px"
          >
            {t("avatar.noAvatars.createNewAvatar")}
          </Button>
        </Flex>
      </Flex>
    );
  }
}
export default withTranslation()(NoAvatars);
